import { useCallback, useEffect, useState } from 'react';

// Factorise le pattern list/create/update/remove + rechargement, dupliqué à l'identique
// pour technologies/projets/formations/experiences dans l'ancien Admin.js monolithique.
export const useCrudResource = ({ fetchAll, create, update, remove }, { showToast, entityLabel }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchAll();
      setItems(data || []);
    } finally {
      setLoading(false);
    }
  }, [fetchAll]);

  useEffect(() => {
    reload();
  }, [reload]);

  const createItem = useCallback(
    async (payload) => {
      const created = await create(payload);
      await reload();
      showToast?.(`${entityLabel} créé(e).`);
      return created;
    },
    [create, reload, showToast, entityLabel]
  );

  const updateItem = useCallback(
    async (id, payload) => {
      const updated = await update(id, payload);
      await reload();
      showToast?.(`${entityLabel} mis(e) à jour.`);
      return updated;
    },
    [update, reload, showToast, entityLabel]
  );

  const removeItem = useCallback(
    async (id) => {
      await remove(id);
      await reload();
      showToast?.(`${entityLabel} supprimé(e).`);
    },
    [remove, reload, showToast, entityLabel]
  );

  return { items, loading, reload, createItem, updateItem, removeItem };
};
